var app = angular.module("leonardo");

var DiscardFormDialog = function ($scope) {

  $scope.confirmation = function (data) {
    $scope.confirm(data);
  };

};

app.controller('DiscardFormDialog', ['$scope',
DiscardFormDialog]);
